import { withStyles } from '@material-ui/core/styles'
import TableRow from '@material-ui/core/TableRow'

const CustomTableRow = withStyles(theme => ({
  root: {
    height: 40
  }
}))(TableRow)

export default CustomTableRow
